var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrontlineioLogoMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 711,
    height: 715,
    viewBox: "0 0 711 715",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M137.797 640.234C53.9613 574.839 0 472.512 0 357.5C0 160.058 159.039 0 355.219 0C475.258 0 581.387 59.9228 645.692 151.667H236.806C218.907 151.667 203.749 164.943 201.275 182.783L137.797 640.234Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M710.438 357.5C710.438 380.428 708.294 402.852 704.194 424.579H353.839C332.03 424.579 315.267 405.161 318.308 383.427L331.56 288.819C334.062 270.999 349.213 257.749 367.091 257.749H696.429C705.554 289.409 710.438 322.88 710.438 357.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M666.064 530.661H329.325C311.454 530.661 296.303 543.902 293.801 561.714L273.583 705.514C299.793 711.718 327.124 715 355.219 715C488.98 715 605.473 640.593 666.064 530.661Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M675.21 710.992C694.666 710.992 710.438 695.076 710.438 675.442C710.438 655.809 694.666 639.893 675.21 639.893C655.754 639.893 639.982 655.809 639.982 675.442C639.982 695.076 655.754 710.992 675.21 710.992Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrontlineioLogoMobile);
export default __webpack_public_path__ + "static/media/frontlineio-logo-mobile.3e1bbb781e5acd5e9e41feef206f8320.svg";
export { ForwardRef as ReactComponent };